import { HeaderWrapper, Logo, Menu, MenuItem, MenuLink } from "./HeaderStyle";
import logo from "../assets/logo.png";


const Header = () => {
  return (
    <HeaderWrapper>
     <Logo src={logo} alt="Logo"/>
     <Menu>
        <MenuItem><MenuLink><a href="#section1">Our Programmes</a></MenuLink></MenuItem>
        <MenuItem><MenuLink><a href="#section2">About Us</a></MenuLink></MenuItem>
        <MenuItem><MenuLink><a href="#section3">Contact Us</a></MenuLink></MenuItem>
      </Menu>
    </HeaderWrapper>
  );
};

export default Header;
